// extracted by mini-css-extract-plugin
export default {"vision":"vision_vision__iQ62Y","content1":"vision_content1__VeUk4","content2":"vision_content2__Ci1M-"};